import React, { useState, Fragment, useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  TextField,
  CardMedia,
  InputAdornment,
} from "@material-ui/core";
import NavBar from "../component/NavBar";
import ModalContainer from "../component/ModalContainer";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { isIpad } from "../constant/StaffOnboardState";
import HttpClient from "../api/HttpClient";
import { useLoading } from "../constant/LoadingContext";
import { useGlobalData } from "../constant/GlobalDataContext";
import moment from "moment";

const MainPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [typeContent, setTypeContent] = useState(""); //select or noRecord

  const { setLoading } = useLoading();
  const [staffOnboardInfo, setStaffOnboardInfo] = useState(null);
  const personalInfo = require("../icons/personal_info.png");
  const otherForm = require("../icons/other_form.png");
  const [step, setStep] = useState(0);

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const isRecruitment = user?.data?.userDataFilter?.some(
    (o) => o.controlArea === "recruitment"
  );

  const isCnB = user?.data?.userDataFilter?.some(
    (o) => o.controlArea === "c&b"
  );

  const RenderAreaJudge = (v: string) => {
    return user?.data?.userDataFilter?.some((o) => o.controlValue === v);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && searchValue !== "") {
        if (step === 2) {
          FetchDocLists();
        } else {
          HandleSearchStaff();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [searchValue]);

  const HandleSearchStaff = async () => {
    setLoading(true);
    HttpClient().HandleWebSearchStaffApi(
      { searchValue, userDataFilter: user?.data?.userDataFilter },
      (data) => {
        const alreadyUpdateOnce = data?.data?.filter((o) => !!o.onlyUpdateOnce);
        const noUpdateOnce = data?.data?.filter((o) => !o.onlyUpdateOnce);
        const notSign = data?.data
          ?.filter((o) => o.staff_signature === null)
          .sort((a, b) => {
            return moment(b.createdAt).diff(moment(a.createdAt));
          });
        
        if (isIpad()) {
          if (!isCnB && !isRecruitment) {
            setLoading(false);
            setTypeContent("noAuthorization");
            setOpen(true);
            return;
          }
          // todo
          if (!notSign?.length) {
            setOpen(true);
            setTypeContent("onlyUpdateOnce");
            setStaffOnboardInfo(null);
          } else {
            setOpen(true);
            setTypeContent("updateForm");
            setStaffOnboardInfo(notSign?.length ? notSign : null);
          }
        } else {
          if (notSign?.length === data?.data?.length) {
            setOpen(true);
            setTypeContent("noSignature");
          } else {
            // two condition:
            // recruitment team only can view 14 days record , C&B can view all record
            if (!!isRecruitment) {
              const only14DaysRecord = data?.data?.filter(
                (o) =>{
                  return (o.joinDate ? moment(o.joinDate) : moment()).isSameOrAfter(moment().subtract(15, "days")) && !!RenderAreaJudge(o.area)
                }
              );
              
              if (!only14DaysRecord?.length) {
                setOpen(true);
                setTypeContent("noAuthorization");
              } else {
                navigate("/main/staffTable", {
                  state: { staffData: only14DaysRecord, searchValue },
                });
              }
            }
            if (!!isCnB) {
              const filteredData = data.data?.filter(
                (o) => !!RenderAreaJudge(o.area)
              );
              if (!filteredData?.length) {
                setOpen(true);
                setTypeContent("noAuthorization");
              } else {
                navigate("/main/staffTable", {
                  state: { staffData: filteredData, searchValue },
                });
              }
            }
          }
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        setTypeContent("noRecord");
        setOpen(true);
      }
    );
  };

  const FetchDocLists = async () => {
    setLoading(true);

    HttpClient().FetchDocListsApi(
      { searchValue, userDataFilter: user?.data?.userDataFilter },
      (data) => {
        const hrConfirmed = data?.data?.filter((o) => !!o.isHrConfirmed);
        const hrNotConfirmed = data?.data?.filter((o) => !o.isHrConfirmed);

        const _area = JSON.parse(hrNotConfirmed[0]?.content || "{}")?.version1
          ?.area;

        if (hrConfirmed?.length === data?.data?.length) {
          setOpen(true);
          setTypeContent("hrConfirmed");
        } else if (!RenderAreaJudge(_area)) {
          setOpen(true);
          setTypeContent("noAuthorization");
        } else {
          navigate("/main/documentLists", {
            state: { searchValue: searchValue },
          });
          localStorage.setItem("searchValue", searchValue);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        setOpen(true);
        setTypeContent("noRecord");
      }
    );
  };

  return (
    <Fragment>
      <Container className={classes.container}>
        <ModalContainer
          open={open}
          setOpen={setOpen}
          type={typeContent}
          staffInfo={staffOnboardInfo}
        />
        <NavBar
          step={step}
          isBack={step !== 0 && isIpad() ? true : false}
          goBack={() => {
            if (step === 1 || step === 2) {
              setStep(0);
            }
          }}
        />
        <div style={{ backgroundColor: "#F0EFF6", minHeight: "90%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "90vh",
            }}
          >
            <Paper
              style={{
                display: "flex",
                flexDirection: "column",
                width: isIpad() ? "70%" : "50%",
                height: "80%",
                padding: "2rem",
                borderRadius: "2rem",
              }}
            >
              {!isIpad() ? (
                <Fragment>
                  <Typography
                    variant="h5"
                    className={classes.title}
                    style={{ paddingTop: "5rem" }}
                  >
                    個人資料表格連結
                  </Typography>
                  <Button
                    variant="contained"
                    color={"primary"}
                    onClick={() => {
                      setTypeContent("select");
                      setOpen(true);
                    }}
                    className={classes.button}
                    startIcon={
                      <CardMedia
                        component="img"
                        image={require("../icons/linker.png")}
                        alt=""
                        className={classes.media}
                      />
                    }
                  >
                    取得連結
                  </Button>
                  <Typography
                    variant="h5"
                    className={classes.title}
                    style={{ paddingTop: "5rem" }}
                  >
                    搜尋員工
                  </Typography>

                  <TextField
                    id="outlined-basic"
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder="輸入員工編號、身份證號碼、手機號碼"
                    // label="文件日期"
                    variant="outlined"
                    className={classes.input}
                    // inputRef={searchInputRef}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          className={classes.adornment}
                          position="end"
                        >
                          <Button
                            startIcon={
                              <CardMedia
                                component="img"
                                image={require("../icons/search.png")}
                                alt=""
                                className={classes.media}
                              />
                            }
                            variant="contained"
                            color={"primary"}
                            onClick={HandleSearchStaff}
                            style={{
                              backgroundColor: "#908DF2",
                              borderRadius: "20px",
                            }}
                          >
                            搜索
                          </Button>
                        </InputAdornment>
                      ),
                      className: classes.input,
                    }}
                  />
                </Fragment>
              ) : (
                <Fragment>
                  {step === 0 ? (
                    <Fragment>
                      <Typography
                        variant="h5"
                        className={classes.ipadTitle}
                        style={{ paddingTop: "5rem" }}
                      >
                        請選擇
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          padding: "4rem 0",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className={classes.imageForm}
                          onClick={() => {
                            if (!isCnB && !isRecruitment) {
                              alert("沒有權限瀏覽該員工紀錄");
                            } else {
                              setStep(1);
                            }
                          }}
                        >
                          <CardMedia
                            component="img"
                            image={personalInfo}
                            alt=""
                            className={classes.arrow}
                          />
                          <Typography
                            style={{
                              color: "#454C96",
                              paddingTop: "1rem",
                            }}
                          >
                            個人資料表格
                          </Typography>
                        </div>
                        <div
                          onClick={() => {
                            if (!isCnB && !isRecruitment) {
                              alert("沒有權限瀏覽該員工紀錄");
                            } else {
                              setStep(2);
                            }
                          }}
                          className={classes.imageForm}
                          style={{ marginLeft: "2rem" }}
                        >
                          <CardMedia
                            onClick={() => {}}
                            component="img"
                            image={otherForm}
                            alt=""
                            className={classes.arrow}
                          />
                          <Typography
                            style={{
                              color: "#454C96",
                              paddingTop: "1rem",
                            }}
                          >
                            其他文件
                          </Typography>
                        </div>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div style={{ margin: "0 3rem" }}>
                        <Typography
                          variant="h5"
                          className={classes.title}
                          style={{ paddingTop: "5rem" }}
                        >
                          {step === 2
                            ? "搜尋員工其他文件"
                            : "搜尋員工個人資料表格"}
                        </Typography>

                        <TextField
                          id="outlined-basic"
                          onChange={(e) => setSearchValue(e.target.value)}
                          placeholder="輸入身份證號碼、手機號碼"
                          // label="文件日期"
                          variant="outlined"
                          className={classes.input}
                          style={{ width: "100%" }}
                          // inputRef={searchInputRef}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                className={classes.adornment}
                                position="end"
                              >
                                <Button
                                  startIcon={
                                    <CardMedia
                                      component="img"
                                      image={require("../icons/search.png")}
                                      alt=""
                                      className={classes.media}
                                    />
                                  }
                                  variant="contained"
                                  color={"primary"}
                                  onClick={
                                    step === 2
                                      ? FetchDocLists
                                      : HandleSearchStaff
                                  }
                                  style={{
                                    backgroundColor: "#908DF2",
                                    borderRadius: "20px",
                                  }}
                                >
                                  搜索
                                </Button>
                              </InputAdornment>
                            ),
                            className: classes.input,
                          }}
                        />
                        {step === 1 && (
                          <div>
                            <Typography
                              variant="h5"
                              className={classes.title}
                              style={{ paddingTop: "5rem" }}
                            >
                              個人資料表格連結
                            </Typography>
                            <Button
                              variant="contained"
                              color={"primary"}
                              onClick={() => {
                                setTypeContent("addNewForm");
                                setOpen(true);
                              }}
                              className={classes.button}
                              startIcon={
                                <CardMedia
                                  component="img"
                                  image={require("../icons/add.png")}
                                  alt=""
                                  className={classes.media}
                                />
                              }
                            >
                              新增表格
                            </Button>
                          </div>
                        )}
                      </div>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </Paper>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export default MainPage;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
  },
  title: { color: "#454C96", fontWeight: 400 },
  ipadTitle: { color: "#84909F", fontWeight: 400, alignSelf: "center" },
  container: {
    // display: "flex",
    height: "100vh",
    borderRadius: "10rem",
  },

  input: {
    margin: theme.spacing(1, 0),
    // borderRadius: 10,
    padding: "3px 15px 3px 5px",

    [`& fieldset`]: {
      borderRadius: 30,
    },
  },
  button: {
    margin: theme.spacing(1, 0),
    width: "50%",
  },
  media: {
    height: "20px",
    margin: "5px",
    objectFit: "contain",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
      width: "20px",
    },
  },
  adornment: {},
  imageForm: {
    width: "10rem",
    height: "10rem",
    backgroundColor: "#F4EFFF",
    display: "flex",
    justifyContent: "center",
    borderRadius: "1rem",
    cursor: "pointer",

    alignItems: "center",
    flexDirection: "column",
  },
  arrow: {
    width: "18px",
    height: "18px",
    margin: "5px",
    objectFit: "contain",
    cursor: "pointer",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
    },
  },
}));
